import Vue from 'vue'
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
    pt_BR: {
        message: {
            about: 'Sobre',
            cards: 'Fichas',
            cart: 'Carrinho',
            change_password: 'Alterar senha',
            change_password_repeat: 'Repita a nova senha',
            change_password_hint: 'Alterar senha (deixe em branco para não alterar)',
            context: 'Contexto',            
            contexts: 'Contextos',
            contexts_select_hint: 'Escolha um ou mais contextos',
            close: 'Fechar',
            email: 'Email',
            filters: 'Filtros',
            home: 'Início', 
            login: 'Login',
            login_validation_name: 'O campo Usuário deve ser preenchdio!',
            login_validation_password: 'Você deve preencher o campo de senha!',
            logout: 'Sair',  
            my_orders: 'Meus pedidos',   
            name: 'Nome',
            no_products_found: 'Nenhum produto foi encontrado!',
            orders: 'Pedidos',
            password: 'Senha',
            products_found: 'Produto(s) encontrado(s)',
            required_email: 'Email deve ser preenchido!',
            required_email_invalid: 'Formato de email invalido!',
            required_name: 'Nome deve ser preenchido!',
            required_name_invalid: 'O campo nome deve ter no máximo 10 caracteres!',
            required_password_invalid: 'A senha deve ser igual!',
            profile: "Perfil",
            section: 'Seção',
            sections: 'Seções',   
            sections_select_hint: 'Escolha um ou mais seções', 
            store:'Loja',
            ufv: 'Universidade Federal de Viçosa',
            update_changes: 'Salvar alterações',
            update_success: 'Alterações salvas com sucesso!',
            update_fail: 'Erro ao salvar alterações',
            username: 'Usuário',
            welcome: 'Bem vindo'
        }
    },
    en_us: {
        message: {
            about: 'About',
            cards: 'Cards',
            cart: 'Cart',
            change_password: 'Change password',
            change_password_repeat: 'Repeat the new password',
            change_password_hint: 'Change password (leave it blank to keep current)',
            context: 'Context',
            contexts: 'Contexts',
            contexts_select_hint: 'Pick one or more contexts',
            close: 'Close',
            email: 'Email',
            filters: 'Filters',
            home: 'Home',
            login: 'Login',
            login_validation_name: 'You must provide a username',
            login_validation_password: 'You must provide a password',
            logout: 'Logout',
            my_orders: 'My orders',
            name: 'Name',
            no_products_found: 'The product list is empty!',
            orders: 'Orders',
            password: 'Password',
            products_found: 'Products found',
            profile: "Profile",
            required_email: 'Email is required',
            required_email_invalid: 'E-mail must be valid',
            required_name: 'Name is required',
            required_name_invalid: 'Name must be less than 10 characters',            
            required_password_invalid: 'The password must match!',
            section: 'Section',
            sections: 'Sections',
            sections_select_hint: 'Pick one or more sections',
            store:'Store',
            ufv: 'Federal University of Viçosa',
            update_changes: 'Save changes',
            update_success: 'Changes saved with success!',
            update_fail: 'Error while trying to update changes!',
            username: 'Username',
            welcome: 'Welcome'
        }
    }
};

const i18n = new VueI18n({
    locale: 'pt_BR',
    messages
});

export default i18n;